export default __webpack_public_path__ + "static/media/profileBg.9c6115d0.jpg";